import Step8 from './Step8';

export default Step8;
